import styled from 'styled-components';

export default styled.div`
  grid-area: content;
  display: grid;
  grid-template-rows: min-content;
  grid-row-gap: 1rem;
  background: ${({ background }) => background || 'transparent'};
  border-radius: 0 0 0.25rem 0.25rem;
  padding-bottom: 1rem;
`;
